<template lang="html">
<div class="container">
  <div class="panel">
  <div class="panel-heading">
    Usuários
    <router-link class="button is-small is-primary is-pulled-right" to="/users/add">Add</router-link>
    <div class="is-clearfix"></div>
  </div>
</div>
  <table class="table">
  <thead>
    <tr>
      <th><abbr title="Position">Codigo</abbr></th>
      <th>Nome</th>
      <th title="Login">Login</th>
      <th title="E-mail">E-mail</th>
      <th title="Status">Status</th>
      <th title="Status">Token</th>
      <th title="Editar">Editar</th>
      <th title="Remover">Remover</th>
      <th title="Remover">Emails</th>
    </tr>
  </thead>
  <tfoot>
    <tr>
      <th><abbr title="Position">Codigo</abbr></th>
      <th>Nome</th>
      <th title="Login">Login</th>
      <th title="E-mail">E-mail</th>
      <th title="Status">Status</th>
      <th title="Status">Token</th>
      <th title="Editar">Editar</th>
      <th title="Remover">Remover</th>
      <th title="Remover">Emails</th>
    </tr>
  </tfoot>
  <tbody>
    <tr v-for="{ use_codigo, use_data } in users">
      <th>{{use_codigo}}</th>
      <td>{{use_data.nome}}</td>
      <td>{{use_data.login}}</td>
      <td>{{use_data.email}}</td>
      <td>{{use_data.status}}</td>
      <td>{{use_data.token}}</td>
      <td>
        <router-link class="button is-warning" :to="`/users/edit/${use_codigo}`">
          <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </router-link>
      </td>
      <td>
        <a class="button is-danger" @click.prevent="remove(use_codigo)">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </a>
      </td>
      <td>
        <router-link class="button is-info" :to="`/users/${use_codigo}/emails`">
          <i class="fa fa-paper-plane" aria-hidden="true"></i>
        </router-link>
      </td>
    </tr>
  </tbody>
</table>
<div v-if="loading" class="sk-folding-cube">
  <div class="sk-cube1 sk-cube"></div>
  <div class="sk-cube2 sk-cube"></div>
  <div class="sk-cube4 sk-cube"></div>
  <div class="sk-cube3 sk-cube"></div>
  Aguarde..
</div>
</div>
</template>

<script>
import swal from 'sweetalert2'
import { listUsers, removeUser } from './users.service'
export default {
  name: 'AppUsersList',
  data () {
    return {
      users: [],
      loading: false
    }
  },
  methods: {
    loadUsers () {
      this.loading = true
      listUsers()
      .then(response => {
        this.users = response
        this.loading = false
      })
    },
    remove (codUser) {
      removeUser(codUser)
      .then(response => {
        swal({
          title: 'Exclusão',
          text: 'Cadastro removido com sucesso!',
          type: 'success',
          showLoaderOnConfirm: true
        })
        .then(() => {
          this.loadUsers()
        })
      })
    }
  },
  mounted () {
    this.loadUsers()
  }
}
</script>

<style lang="css">
.sk-folding-cube {
  margin: 20px auto;
  width: 40px;
  height: 40px;
  top: 45%;
  left: 45%;
  position: absolute;
  -webkit-transform: rotateZ(45deg);
          transform: rotateZ(45deg);
}

.sk-folding-cube .sk-cube {
  float: left;
  width: 50%;
  height: 50%;
  position: relative;
  -webkit-transform: scale(1.1);
      -ms-transform: scale(1.1);
          transform: scale(1.1);
}
.sk-folding-cube .sk-cube:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #333;
  -webkit-animation: sk-foldCubeAngle 2.4s infinite linear both;
          animation: sk-foldCubeAngle 2.4s infinite linear both;
  -webkit-transform-origin: 100% 100%;
      -ms-transform-origin: 100% 100%;
          transform-origin: 100% 100%;
}
.sk-folding-cube .sk-cube2 {
  -webkit-transform: scale(1.1) rotateZ(90deg);
          transform: scale(1.1) rotateZ(90deg);
}
.sk-folding-cube .sk-cube3 {
  -webkit-transform: scale(1.1) rotateZ(180deg);
          transform: scale(1.1) rotateZ(180deg);
}
.sk-folding-cube .sk-cube4 {
  -webkit-transform: scale(1.1) rotateZ(270deg);
          transform: scale(1.1) rotateZ(270deg);
}
.sk-folding-cube .sk-cube2:before {
  -webkit-animation-delay: 0.3s;
          animation-delay: 0.3s;
}
.sk-folding-cube .sk-cube3:before {
  -webkit-animation-delay: 0.6s;
          animation-delay: 0.6s;
}
.sk-folding-cube .sk-cube4:before {
  -webkit-animation-delay: 0.9s;
          animation-delay: 0.9s;
}
@-webkit-keyframes sk-foldCubeAngle {
  0%, 10% {
    -webkit-transform: perspective(140px) rotateX(-180deg);
            transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  } 25%, 75% {
    -webkit-transform: perspective(140px) rotateX(0deg);
            transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  } 90%, 100% {
    -webkit-transform: perspective(140px) rotateY(180deg);
            transform: perspective(140px) rotateY(180deg);
    opacity: 0;
  }
}

@keyframes sk-foldCubeAngle {
  0%, 10% {
    -webkit-transform: perspective(140px) rotateX(-180deg);
            transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  } 25%, 75% {
    -webkit-transform: perspective(140px) rotateX(0deg);
            transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  } 90%, 100% {
    -webkit-transform: perspective(140px) rotateY(180deg);
            transform: perspective(140px) rotateY(180deg);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// UsersList.vue?3eb1f444